require("!!E:\\sqbang\\code\\wx\\node_modules\\script-loader\\addScript.js")(require("!!E:\\sqbang\\code\\wx\\node_modules\\raw-loader\\index.js!E:\\sqbang\\code\\wx\\node_modules\\zepto\\dist\\zepto.js"))

/*** EXPORTS FROM exports-loader ***/
module.exports = window.Zepto;


//////////////////
// WEBPACK FOOTER
// ./~/zepto/dist/zepto.js
// module id = 78
// module chunks = 0